'use client';

import { useSegmentTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { TrackingFunction } from '../types';

export const useFloatingDisclaimerDismissedTracking = (props = {}, autoTrack: boolean = false): TrackingFunction => {
  return useSegmentTrack(
    {
      eventName: ANALYTICS_EVENTS.FLOATING_DISCLAIMER_DISMISSED,
      properties: props,
    },
    autoTrack,
  );
};
